// The single uppercase initial to show in the header avatar, from the logged-in
// user's name or email (falls back to "U").
export function avatarInitial(user) {
  const source = (user && (user.name || user.email)) || "";
  const trimmed = String(source).trim();
  if (!trimmed) {
    return "U";
  }
  return trimmed.charAt(0).toUpperCase();
}
